// The board used to save a card order under `<lane kind>_<view id>` and never read it back. Custom views set
// the view id to Math.random(), so every custom view switch on the board left a new key behind (#35502).
const OLD_BOARD_ORDER_KEY = /^(status|category|priority|group|team)_(-?\d+(\.\d+)?|undefined)$/;

export const isOldBoardOrderKey = (key: string): boolean => OLD_BOARD_ORDER_KEY.test(key);

/** Removes the keys the board's card order left in storage. Returns how many it removed. */
export const clearOldBoardOrderKeys = (storage: Storage = window.localStorage): number => {
  try {
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key && isOldBoardOrderKey(key)) keys.push(key);
    }
    keys.forEach((key) => storage.removeItem(key));
    return keys.length;
  } catch {
    // guard clause - storage can be unavailable (blocked site data); there is nothing to clear then
    return 0;
  }
};
